import SettingsForm from "./SettingsForm";
// import FormLayout from "../../../components/Layout/FormLayout";
import CrudFormLayout from "../../../components/Layout/CrudFormLayout";

const SettingsFormContainer = ({ settingsData, submitFormHandler }) => {
    // console.log("settingsData", settingsData, !!settingsData);
    console.log("settingsData", settingsData)
  const initialValues = {
    website_name: settingsData?.website_name || "",
    website_url: settingsData?.website_url || "",
    tag_line: settingsData?.tag_line || "",
    short_name: settingsData?.short_name || "",
    address: settingsData?.address || "",
    mobile: settingsData?.mobile || "",
    email: settingsData?.email || "",
    logo_image: settingsData?.logo_image || "",
    // header_image: settingsData?.header_image || "",
    // footer_image: settingsData?.footer_image || "",
    fav_image: settingsData?.fav_image || "",
    vat_type: settingsData?.vat_type || "",
    currency: settingsData?.currency || "",
    copyright: settingsData?.copyright || "",
    // year: settingsData?.year || "",
    // month: settingsData?.month || "",
    // background_image: settingsData?.background_image || "",
    // point: settingsData?.point || "",
    // introducer_label: settingsData?.introducer_label || "",
    // reg_prefix: settingsData?.reg_prefix || "",
    // reg_no: settingsData?.reg_no || "",
    // reg_expiry: settingsData?.reg_expiry || "",
    // reg_type: settingsData?.reg_type || "",
    // reset_sequence_in_month: settingsData?.reset_sequence_in_month || "",
    // starting_digit: settingsData?.starting_digit || "",
    // days_of_week: settingsData?.days_of_week || "",
    // package_in_medical_form: settingsData?.package_in_medical_form || "",
  };

  return (
    
    <CrudFormLayout
      initialValues={initialValues}
      apiHandler={submitFormHandler}
      noButton={true}
      enableReinitialize={true}
    >
      <SettingsForm />
    </CrudFormLayout>
    
  );
};

export default SettingsFormContainer;
